export default __webpack_public_path__ + "static/media/darkredmagic.99dc3221.png";